import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
    ExtraOptions,
    PreloadAllModules,
    Router,
    RouterModule,
} from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { PpHttpModule } from '@penpencil/common';
import { environment } from 'environments/environment';
import { AppUrl } from './core/constants/app-url';
import { CommonModule } from '@angular/common';
import { PpTableModule } from '@penpencil/table';
import { PpFormsModule } from '@penpencil/forms';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { MQTT_OPTIONS } from './core/constants/mqtt';
import { FirebaseApp, initializeApp } from 'firebase/app';
export let firebaseApp: FirebaseApp;
export let remoteConfig: any;
import { getRemoteConfig } from 'firebase/remote-config';
import { MqttModule } from 'ngx-mqtt';

firebaseApp = initializeApp(
    JSON.parse(localStorage.getItem('user'))?.organization?._id ===
        environment.orgIds.xylem
        ? environment.firebase.XYLEM
        : environment.firebase.PW,
);
remoteConfig = getRemoteConfig();

// Expose tinymce instance to the window
declare const require: any;
(window as any).tinymce = require('tinymce');

// import synchronous mathtype-tinymce5 package
require('@wiris/mathtype-tinymce5');

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
};

@NgModule({
    declarations: [AppComponent],
    imports: [
        CommonModule,
        MqttModule.forRoot(MQTT_OPTIONS),
        PpTableModule.forRoot(environment.apiConfig),
        PpFormsModule.forRoot(environment.apiConfig),
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,
        EditorModule,

        // 3rd party modules that require global configuration via forRoot
        MarkdownModule.forRoot({}),
        PpHttpModule.forRoot(environment.apiConfig),
    ],
    bootstrap: [AppComponent],
    providers: [
        AppUrl,
        { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
    ],
})
export class AppModule {}
